var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDisclaimer = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "480pt",
    viewBox: "-31 0 479 480",
    width: "480pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m376.5 40c0-22.398438-17.601562-40-40-40h-296c-22.398438 0-40 17.601562-40 40v64h64v336c0 22.398438 17.601562 40 40 40h272c22.398438 0 40-17.601562 40-40v-40h-40zm-312 48h-48v-48c0-13.601562 10.398438-24 24-24s24 10.398438 24 24zm16 352v-400c0-8.800781-3.199219-16.800781-8-24h264c13.601562 0 24 10.398438 24 24v360h-232v40c0 13.601562-10.398438 24-24 24s-24-10.398438-24-24zm320-24v24c0 13.601562-10.398438 24-24 24h-240c5.601562-7.199219 8-15.199219 8-24v-24zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m280.5 256h64v16h-64zm0 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m96.5 256h168v16h-168zm0 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m184.5 288h160v16h-160zm0 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m96.5 288h72v16h-72zm0 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m240.5 352h104v16h-104zm0 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m96.5 352h128v16h-128zm0 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m206.898438 163.199219 9.601562 6.402343 9.601562-6.402343c28.796876-19.199219 46.398438-52 46.398438-86.398438v-26.402343l-56-18.398438-56 18.398438v26.402343c0 34.398438 17.601562 67.199219 46.398438 86.398438zm-30.398438-101.597657 40-13.601562 40 13.601562v15.199219c0 29.597657-14.398438 56.800781-39.199219 73.597657h-.800781l-.800781-.796876c-24.800781-16-39.199219-44-39.199219-73.601562zm0 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m240.5 80.800781-16-1.601562c-1.601562 13.601562-8.800781 26.402343-20 34.402343l8.800781 13.597657c15.199219-11.199219 25.597657-28 27.199219-46.398438zm0 0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m144.5 320h200v16h-200zm0 0"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m96.5 320h32v16h-32zm0 0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m184.5 224h160v16h-160zm0 0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m96.5 224h72v16h-72zm0 0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m160.5 184h112v16h-112zm0 0"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDisclaimer, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/disclaimer.972965fe.svg";
export { ForwardRef as ReactComponent };